import { CompanyName } from 'modules/utils/ConfigUtils';

export const translations = {
  en: {
    ques1: 'Do you have health insurance?',
    ques2: `Have you been a patient at an ${CompanyName} facility previously?`,
    ques3: 'Have you changed insurances since you were last seen at an Intermountain facility?',
    desc1:
      'Insurance information is needed to bill for COVID-19 tests. Copayments and deductibles may apply based on insurance plan.',
    desc2: 'If additional insurance verification is needed, you may receive a follow-up call.',
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown',
    instructions: 'Please provide your insurance information:',
    field_1: 'Member Number/ID',
    field_1_err_1: '20 characters maximum',
    field_1_err_2: 'Please enter Member Number/ID',
    field_2: 'Group Number/ID',
    field_2_err_1: '20 characters maximum',
    field_3: 'Patient relationship to subscriber:',
    field_3_err_1: 'Please enter Patient relationship to subscriber',
    dropdown_item_0: 'Self',
    dropdown_item_1: 'Spouse',
    dropdown_item_2: 'Child',
    dropdown_item_3: 'Stepchild',
    dropdown_item_4: 'Grandchild',
    dropdown_item_5: 'Life Partner',
    dropdown_item_6: 'Overage Dependent',
    dropdown_item_7: 'Other',
    field_4: 'First name on card',
    field_4_err_1: 'Maximum 16 characters',
    field_4_err_2: 'Please enter first name on card',
    field_5: 'Middle name on card',
    field_5_err_1: 'Maximum 16 characters',
    field_6: 'Last name on card',
    field_6_err_1: 'Maximum 26 characters',
    field_6_err_2: 'Please enter Last name on card',
    invalid_char_err: 'No numbers or special characters or space allowed'
  },
  es: {
    ques1: '¿Tiene seguro médico?',
    ques2: '¿Ha sido un paciente en alguno de los establecimientos de Intermountain?',
    ques3:
      '¿Cambió de seguro desde que fue visto por última vez en un establecimiento de Intermountain?',
    desc1:
      'Necesitamos la información del seguro para facturarle por las pruebas de COVID-19. Pueden aplicarse copagos y deducibles según el plan de seguro.',
    desc2:
      'Recibirá una llamada de seguimiento de ser necesario hacer una verificación adicional de su seguro.',
    yes: 'Sí',
    no: 'No',
    unknown: 'No sé',
    instructions: 'Por favor, proporcione la información de su seguro:',
    field_1: 'Número de miembro o identificación',
    field_1_err_1: 'Por favor use 20 caracteres o menos',
    field_1_err_2: 'Por favor introduzca su Número/ID de miembro',
    field_2: 'Número de grupo o identificación',
    field_2_err_1: 'Por favor use 20 caracteres o menos',
    field_3: 'Relación del paciente con el suscriptor:',
    field_3_err_1: 'Ingrese la relación del paciente con el suscriptor',
    dropdown_item_0: 'Yo mismo/a',
    dropdown_item_1: 'Cónyuge',
    dropdown_item_2: 'Hijo/a',
    dropdown_item_3: 'Hijastro/a',
    dropdown_item_4: 'Nieto/a',
    dropdown_item_5: 'Pareja',
    dropdown_item_6: 'Dependiente mayor de edad',
    dropdown_item_7: 'Otro',
    field_4: 'Primer nombre en la tarjeta',
    field_4_err_1: 'Por favor use 16 caracteres o menos',
    field_4_err_2: 'Por favor introduzca el primer nombre en la tarjeta',
    field_5: 'Segundo nombre en la tarjeta',
    field_5_err_1: 'Por favor use 16 caracteres o menos',
    field_6: 'Apellido en la tarjeta',
    field_6_err_1: 'Por favor use 26 caracteres o menos',
    field_6_err_2: 'Por favor introduzca el apellido en la tarjeta',
    invalid_char_err: 'No se permiten números ni caracteres especiales ni espacios'
  }
};
